import React from "react";
import { DiUbuntu, DiWindows } from "react-icons/di";
import {
  SiVisualstudiocode,
  SiPostman,
  SiVercel,
  SiMacos,
  SiAndroidstudio,
  SiXcode,
} from "react-icons/si";

const tools = [
  { name: "macOS", icon: <SiMacos color="#000000" /> },
  { name: "Ubuntu", icon: <DiUbuntu color="#000000" /> },
  { name: "Windows", icon: <DiWindows color="#007ACC" /> },
  { name: "VS Code", icon: <SiVisualstudiocode color="#007ACC" /> },
  { name: "Postman", icon: <SiPostman color="#F44336" /> },
  { name: "Android Studio", icon: <SiAndroidstudio color="#3DDC84" /> },
  { name: "Vercel", icon: <SiVercel color="#111827" /> },
  { name: "Xcode", icon: <SiXcode color="#007ACC" /> },
];

function Toolstack() {
  return (
    <div className="stack-grid stack-grid-tools">
      {tools.map(({ name, icon }) => (
        <div className="tech-icons" key={name} title={name}>
          <span className="tech-icon-glyph" aria-hidden="true">
            {icon}
          </span>
          <span className="tech-icon-label">{name}</span>
        </div>
      ))}
    </div>
  );
}

export default Toolstack;
